import { useMutation, useQueryClient } from '@tanstack/react-query';
import { configApi } from '../../configApi';

// Deletar documento
interface IDeleteDocumentPayload {
  documentId: string;
}

const deleteDocument = async (documentId: string) => {
  const response = await configApi.delete(
    `/research-proposal-defense/documents/${documentId}/`
  );
  return response.data;
};

export const useDeleteProjectDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IDeleteDocumentPayload) => deleteDocument(data.documentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['project_submission'] });
    },
  });
};

// Baixar documento
interface IDownloadResponse {
  download_url: string;
  filename: string;
  file_size: number;
  mime_type: string;
  expires_in: number;
}

export const downloadDocument = async (documentId: string, filename: string) => {
  try {
    // Obter URL de download pré-assinada
    const response = await configApi.get<IDownloadResponse>(
      `/research-proposal-defense/documents/${documentId}/download/`
    );

    const { download_url, filename: apiFilename } = response.data;

    // Usar o nome do arquivo da API ou o fornecido como fallback
    const finalFilename = apiFilename || filename;

    // Criar link para download usando a URL pré-assinada
    const link = document.createElement('a');
    link.href = download_url;
    link.setAttribute('download', finalFilename);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    throw error;
  }
};
